import {createQueryKeys} from '@lukemorales/query-key-factory'
import {api} from 'api'

export const bookingAgencies = createQueryKeys('bookingAgencies', {
  show: (id: number) => ({
    queryKey: [id],
    queryFn: () => api.bookingAgencies.show(id),
  }),
})
